/*
  Entrypoint to the application
*/

import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import { SnackbarProvider } from 'notistack';
import { getCurrentUser, signInWithRedirect, signOut } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import '@aws-amplify/ui-react/styles.css';

import Navigation from './Components/Navigation'
import ScrollToTop from './Utils/ScrollToTop'
import Routes from './Routes';
import './App.css';
import loginBackground from './Assets/login-background.jpg';

// Landing Page Component using the custom background
const LandingPage = () => {
  return (
    <div style={{
      backgroundImage: `url(${loginBackground})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      height: '100vh',
      width: '100vw',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end', // Content on the right
      overflow: 'hidden'
    }}>
      <div style={{
        backgroundColor: 'rgba(255, 255, 255, 0.96)',
        padding: '2.5rem',
        borderRadius: '12px',
        marginRight: '10%', // Spacing from right edge
        boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
        maxWidth: '400px',
        width: '90%',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem'
      }}>
        <h1 style={{ margin: 0, color: '#2c3e50', fontSize: '2rem' }}>KinInfo</h1>
        <p style={{ margin: 0, color: '#555', lineHeight: '1.6' }}>
          Welcome to your family history record.<br />
          Please sign in to continue.
        </p>
        <button
          onClick={() => signInWithRedirect()}
          style={{
            backgroundColor: '#0055aa',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            fontSize: '1.1rem',
            fontWeight: '600',
            borderRadius: '6px',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#004499'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#0055aa'}
        >
          Sign In
        </button>
        <p style={{ margin: 0, color: '#d32f2f', fontWeight: 'bold', fontSize: '0.9rem' }}>
          As of 12/20 updates to security requires all users to go through the forgot password flow to recover their accounts.
        </p>
      </div>
    </div>
  );
};

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkUser = async () => {
      try {
        const currentUser = await getCurrentUser();
        setUser(currentUser);
      } catch (error) {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    checkUser();

    // Listen for auth events
    const unsubscribe = Hub.listen('auth', ({ payload }) => {
      switch (payload.event) {
        case 'signInWithRedirect':
        case 'signIn':
          checkUser();
          break;
        case 'signOut':
          setUser(null);
          break;
      }
    });

    return unsubscribe;
  }, []);

  if (loading) {
    return null; // or a loading spinner
  }

  if (!user) {
    return <LandingPage />;
  }

  return (
    <SnackbarProvider maxSnack={3} anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}>
      <div className="App">
        <Router>
          <ScrollToTop>
            <Navigation user={user} signOut={signOut} />
            <div style={{ marginTop: 80 }}>
              <Routes />
            </div>
          </ScrollToTop>
        </Router>
      </div>
    </SnackbarProvider>
  );
}

export default App;